import { of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
// NGRX
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// Services
import { PatientImageChangeRequestService } from '../_services/patients-image-change-request.service';
// State
import { AppState } from '../../reducers';
// Actions

import {
  ClearPatienImageChangeRequesttErrors,
  PatientImageChangeRequestActionToggleLoading,
  PatientsImageChangeRequestPageCancelled,
  PatientsImageChangeRequestPageToggleLoading,
  PatientsImageChangeRequestsPageLoaded,
  PatientsImageChangeRequestsPageRequested,
  DenyPatientImageChangeRequest,
  ApprovePatientImageChangeRequest,
  PatientImageChangeRequestDenied,
  PatientImageChangeRequestApproved,
  ThrowPatientImageChangeRequestError,
  FirePatientImageChangeRequestSuccess,
} from '../_actions/patient-image-change-request.actions';
import { TranslateService } from '@ngx-translate/core';
import { LayoutUtilsService, MessageType } from '../../_base/crud';

@Injectable()
export class PatientsImageChangeRequestEffects {
  showActionLoadingDistpatcher = PatientImageChangeRequestActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = PatientImageChangeRequestActionToggleLoading({ isLoading: false });

  loadPatientsImageChangeRequestsPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientsImageChangeRequestsPageRequested),
      tap(() => {
        this.store.dispatch(PatientsImageChangeRequestPageToggleLoading({ isLoading: true }));
      }),
      mergeMap((action) => {
        return this.patientsImageChangeRequestService.findRequests(action.page).pipe(
          map((res) => {
            return PatientsImageChangeRequestsPageLoaded({
              requests: res.data,
              totalCount: res.count,
              page: action.page,
            });
          }),
          catchError(() => {
            return of(PatientsImageChangeRequestPageCancelled());
          }),
        );
      }),
      tap(() => {
        this.store.dispatch(PatientsImageChangeRequestPageToggleLoading({ isLoading: false }));
      }),
    ),
  );

  @Effect()
  denyPatientImageChangeRequest$ = this.actions$.pipe(
    ofType(DenyPatientImageChangeRequest),
    mergeMap((action) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.patientsImageChangeRequestService.denyRequest(action.request, action.reason).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return ThrowPatientImageChangeRequestError({ error: res.error });
          } else {
            this.layoutUtility.showActionNotification(
              this.translate.instant('PATIENT.IMAGE_REQUESTS.DENY_REQUEST_SIMPLE.MESSAGE'),
              MessageType.Update,
              3000,
              true,
              false,
            );
            this.store.dispatch(ClearPatienImageChangeRequesttErrors());
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              FirePatientImageChangeRequestSuccess({
                action_type: 'PatientImageChangeRequestDenied',
              }),
            );
            return PatientImageChangeRequestDenied({ ...action });
          }
        }),
      );
    }),
  );

  @Effect()
  approvePatientImageChangeRequest$ = this.actions$.pipe(
    ofType(ApprovePatientImageChangeRequest),
    mergeMap((action) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.patientsImageChangeRequestService.approveRequest(action.request).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return ThrowPatientImageChangeRequestError({ error: res.error });
          } else {
            this.layoutUtility.showActionNotification(
              this.translate.instant('PATIENT.IMAGE_REQUESTS.APPROVE_REQUEST_SIMPLE.MESSAGE'),
              MessageType.Update,
              3000,
              true,
              false,
            );
            this.store.dispatch(ClearPatienImageChangeRequesttErrors());
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              FirePatientImageChangeRequestSuccess({
                action_type: 'PatientImageChangeRequestApproved',
              }),
            );
            return PatientImageChangeRequestApproved({ ...action });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private patientsImageChangeRequestService: PatientImageChangeRequestService,
    private store: Store<AppState>,
    private layoutUtility: LayoutUtilsService,
    private translate: TranslateService,
  ) {}
}
